import * as React from "react";

export default class SecondLayer extends React.Component{
    static self
    constructor(props) {
        super(props);
        this.state = {
            title:'No Title',
            body:'loading...',
            onDismiss: null,
        }
        SecondLayer.self = this
    }
    static show(title, body, onDismissCallback = null){
        SecondLayer.self.setState({
            title:title,
            body:body,
            onDismiss: onDismissCallback,
        })
        document.getElementById('div-layer2').style.display = 'block'
        document.body.style.overflow = 'hidden'
    }

    static dismiss(){
        if (SecondLayer.self.state.onDismiss) {
            SecondLayer.self.state.onDismiss();
        }
        document.getElementById('div-layer2').style.display = 'none'
        document.body.style.overflow = 'auto'
    }
    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        return (
            <>
                <style>
                    {`
                        #div-layer2 .btn-left-menu {
                            padding: 8px 16px 8px 0 !important;
                        }
                    `}
                </style>
            <div id={'div-layer2'} style={{
                position:"absolute",
                display:'none',
                left:0,
                right:0,
                bottom:0,
                top:0,
                background:'#fff',
                zIndex:30,
                fontFamily
            }}>

                <div className={'base-toolbar'} style={{
                    padding:'8px 16px',
                    boxShadow:'0 0 30px #000',
                    position: 'fixed', 
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex:31,
                    lineHeight:'4vh',
                    height:'4vh',
                    fontFamily,
                    backgroundColor:'#395d9a',
                    color:'white'
                }}>
                <div className={'col col-sm-12'}>
                        <span style={{fontSize:'16px', fontFamily}}>
                        <b>
                            <span className={'fa fa-angle-double-right'}/>{this.state.title}
                        </b>
                    </span>

                        <button style={{
                            float:'right',
                            marginRight:'24px',
                            paddingLeft:'8px',
                            fontFamily,
                            background: 'transparent',
                            border: 'none',
                            color: 'white'
                        }} className={'btn danger'} onClick={SecondLayer.dismiss}>
                        <span className={'fa fa-times'}/> Close
                    </button>

                </div>
            </div>
                <div className={'row'} style={{
                    height:'calc(100vh - 4vh)',
                    marginTop:'4vh',
                    float:'left',
                    width:'100%',
                    marginLeft:0,
                    fontFamily,
                    overflowY: 'hidden'
                }}>
                {this.state.body}
                </div>
            </div>
            </>
        );
    }
}